/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type { GetApiMenuManagerQueryResponse } from '../models/GetApiMenuManager.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiMenuManagerQueryResponseSchema } from '../zod/getApiMenuManagerSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiMenuManagerQueryKey = () =>
  [{ url: '/api/menu/manager' }] as const;

export type GetApiMenuManagerQueryKey = ReturnType<
  typeof getApiMenuManagerQueryKey
>;

/**
 * {@link /api/menu/manager}
 */
export async function getApiMenuManager(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiMenuManagerQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/menu/manager`, ...requestConfig });
  return getApiMenuManagerQueryResponseSchema.parse(res.data);
}

export function getApiMenuManagerQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiMenuManagerQueryKey();
  return queryOptions<
    GetApiMenuManagerQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiMenuManagerQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiMenuManager(config);
    },
  });
}

/**
 * {@link /api/menu/manager}
 */
export function useGetApiMenuManager<
  TData = GetApiMenuManagerQueryResponse,
  TQueryData = GetApiMenuManagerQueryResponse,
  TQueryKey extends QueryKey = GetApiMenuManagerQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiMenuManagerQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiMenuManagerQueryKey();

  const query = useQuery(
    {
      ...getApiMenuManagerQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
